/**
 * useMapControls Hook
 *
 * Manages map controls logic (zoom, location)
 * following Single Responsibility Principle
 */

import {useState, useCallback} from 'react';

export interface UseMapControlsProps {
  onGetCurrentLocation: () => Promise<void>;
}

export interface UseMapControlsReturn {
  isLocating: boolean;
  handleZoomIn: () => void;
  handleZoomOut: () => void;
  handleMyLocation: () => Promise<void>;
}

export const useMapControls = ({
  onGetCurrentLocation
}: UseMapControlsProps): UseMapControlsReturn => {
  const [isLocating, setIsLocating] = useState(false);

  const handleZoomIn = useCallback(() => {
    // This will be handled by the parent component's viewState
    // The hook just provides the callback interface
  }, []);

  const handleZoomOut = useCallback(() => {
    // This will be handled by the parent component's viewState
    // The hook just provides the callback interface
  }, []);

  const handleMyLocation = useCallback(async () => {
    setIsLocating(true);
    try {
      await onGetCurrentLocation();
    } catch (error) {
      // Error handling should be done by the parent component
    } finally {
      setIsLocating(false);
    }
  }, [onGetCurrentLocation]);

  return {
    isLocating,
    handleZoomIn,
    handleZoomOut,
    handleMyLocation
  };
};
